import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  PAYMENT_METHODS,
  PAYMENT_PROVIDER,
} from '../../components/payment/constants';
import { FLOWS_ENUM } from '../../common/enums';
import {
  selectPaymentID,
  selectSelectedPaymentMethod,
} from '../../store/slices/payment/paymentSelectors';
import { checkTaxPaymentAsync } from '../../store/slices/payment/paymentThunk';
import { selectConfigSettings } from '../../store/slices/config/configSelectors';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';
import Payment from '../../components/payment/common/GenericPayment/Payment';
import { isGeneric } from 'src/components/payment/common/utils';
import FlowLayout from 'src/components/layout/FlowLayout';
import { useAppDispatch } from 'src/store/store';
import { goToPreviousStep } from 'src/store/slices/flow/flowSlice';

const TaxPayment = () => {
  const dispatch = useAppDispatch();
  const placeNavigate = usePlaceNavigate();

  const paymentID = useSelector(selectPaymentID);
  const settings = useSelector(selectConfigSettings);
  const selectedPaymentMethod = useSelector(selectSelectedPaymentMethod);
  const provider = settings.paymentProcessor as PAYMENT_PROVIDER | undefined;

  const redirectUrl = useMemo(() => {
    if (selectedPaymentMethod === PAYMENT_METHODS.CHECK) {
      return '/tax-success';
    }
    if (isGeneric(provider)) {
      return '/payment-redirect';
    }
    return '/apply-success';
  }, [provider, selectedPaymentMethod]);

  const handleBackClick = useCallback(() => {
    dispatch(goToPreviousStep());
  }, [dispatch]);

  const onSuccess = useCallback(
    (omitCheck: boolean) => {
      if (!omitCheck && paymentID) {
        dispatch(
          checkTaxPaymentAsync(String(paymentID), () => {
            placeNavigate(redirectUrl);
          })
        );
      }
      placeNavigate(redirectUrl);
    },
    [paymentID, placeNavigate, dispatch, redirectUrl]
  );

  return (
    <FlowLayout
      flow={FLOWS_ENUM.PAY_TOT}
      onBack={handleBackClick}
      omitNavigationForward
      showBack
      title="Pay Tax"
    >
      <Payment
        flow={FLOWS_ENUM.PAY_TOT}
        onSuccess={onSuccess}
        permitIdentifier={undefined}
        singlePaymentButton={isGeneric(provider)}
      />
    </FlowLayout>
  );
};

export default TaxPayment;
